import * as React from "react";
import { Row, Col, Input } from "antd";
import signature from "../../assets/images/signature.png";
import { TPaymentConfirmationPresentationModel } from "../../../presenter/payment/model/PaymentConfirmationPresentationModel";
import Text from "antd/lib/typography/Text";
import TextArea from "antd/lib/input/TextArea";
import { DownCircleOutlined } from "@ant-design/icons";

const TransferPaymentForm = ({
  paymentConfirmationData,
  translate
}: {
  paymentConfirmationData: TPaymentConfirmationPresentationModel;
  translate: any;
}) => {
  return (
    <React.Fragment>
      <div className="content-container">
        <div className="content-section content-section-border">
          <Row className={"group-items"}>
            <Text className={"label"}>
              {translate("payment_confirmation_page.description_transfer")}
            </Text>
            <TextArea
              readOnly
              rows={3}
              className={"input"}
              value={paymentConfirmationData.description}
            />
          </Row>
          <Row className={"group-items"} gutter={[8, 8]}>
            <Col className={"label-container"}>
              <Text className={"label"}>
                {translate(
                  "payment_confirmation_page.account_and_provision_currency"
                )}
              </Text>
            </Col>
            <Col lg={20} sm={19} xs={24}>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.coverageAccount}
              />
            </Col>
            <Col lg={4} sm={5} xs={24}>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.coverageCurrency}
              />
            </Col>
          </Row>
          <Row className={"group-items"} gutter={[8, 8]}>
            <Col lg={12} sm={12} xs={24}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.processing_date")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.processingDate}
              />
            </Col>
            <Col lg={12} sm={12} xs={24} className={"signature-wrapper"}>
              <img src={signature} alt="Bank stamp" />
            </Col>
          </Row>
        </div>
        <div className="content-section content-section-emphasize">
          <Row>
            <Text className={"content-section-title"}>
              {translate("payment_confirmation_page.source")}
            </Text>
          </Row>
          <Row className={"group-items"} gutter={[8, 8]}>
            <Col lg={12} sm={24} xs={24}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.account")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.senderAccount}
              />
            </Col>
            <Col lg={8} sm={19} xs={16}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.amount")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.amount}
              />
            </Col>
            <Col lg={4} sm={5} xs={8}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.currency")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.sourceCurrency}
              />
            </Col>
          </Row>

          <Row className={"content-section-icon-wrapper"}>
            <DownCircleOutlined className={"content-section-icon"} />
          </Row>

          <Row>
            <Text className={"content-section-title"}>
              {translate("payment_confirmation_page.destination")}
            </Text>
          </Row>
          <Row className={"group-items"} gutter={[8, 8]}>
            <Col lg={12} sm={24} xs={24}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.account")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.receiverAccount}
              />
            </Col>
            <Col lg={8} sm={19} xs={16}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.amount")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.buyAmount}
              />
            </Col>
            <Col lg={4} sm={5} xs={8}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.currency")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.destinationCurrency}
              />
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TransferPaymentForm;
